import type {
  CTA,
  HeadingWithAccentedText as HeadingWithAccentedTextType,
  Image
} from '@ps/web-martech-cms-types';
import classNames from 'clsx';
import React from 'react';

import { CMSCTA, CMSImage } from '@swf/cms';

import HeadingWithAccentedText from '../HeadingWithAccentedText/HeadingWithAccentedText';

import styles from './Tile.scss';

interface Props {
  image?: Image;
  text?: string;
  heading: HeadingWithAccentedTextType;
  cta: CTA;
  subheading?: string;
  description?: string;
  classes?: {
    image?: string;
    heading?: string;
    subheading?: string;
    text?: string;
    description?: string;
    cta?: string;
  };
}

const Tile: React.FC<Props> = ({
  image,
  text = '',
  heading,
  cta,
  subheading,
  description,
  classes
}) => (
  <div className={styles.root}>
    <CMSImage className={classNames(styles.image, classes?.image)} {...image} />
    <div className={styles.content}>
      <HeadingWithAccentedText
        className={classNames(styles.heading, classes?.heading)}
        {...heading}
      />
      <p className={classNames(styles.subheading, classes?.subheading)}>{subheading}</p>
      <p className={classNames(styles.text, classes?.text)}>{text}</p>
      <p className={classNames(styles.description, classes?.description)}>{description}</p>
      <CMSCTA className={classNames(styles.cta, classes?.cta)} {...cta} />
    </div>
  </div>
);

export default Tile;
